module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Black.22e53726.png";